module.exports = __webpack_public_path__ + "img/组 7@2x.a3ca7f02.png";